
import { css } from 'lit';
export default css`
.monogram-card {margin-left: 1rem;margin-right: 1rem;display: flex;flex-direction: row;justify-content: flex-start
}@media (min-width: 1024px) {.monogram-card {margin-left: 2rem
  }.monogram-card {flex-direction: column
  }
}.monogram-card__wrapper {margin-left: 1rem
}.monogram-card__wrapper {display: flex
}.monogram-card__wrapper {flex-direction: column
}.monogram-card__wrapper {justify-content: flex-start
}@media (min-width: 1024px) {.monogram-card__wrapper {margin-left: 0px
  }
}.monogram-card__icon {margin-bottom: 1.5rem
}.monogram-card__icon {height: 2rem
}.monogram-card__icon {width: 2rem
}.monogram-card__icon {flex-shrink: 0
}.monogram-card__icon {--tw-text-opacity: 1;color: rgba(107, 31, 153, var(--tw-text-opacity))
}@media (min-width: 1024px) {.monogram-card__icon {height: 3rem
  }
}@media (min-width: 1024px) {.monogram-card__icon {width: 3rem
  }
}.monogram-card__link {margin-bottom: 1rem
}.monogram-card__link {margin-top: 2px
}.monogram-card__body-text {margin-bottom: 0px
}.monogram-card__arrow {margin-left: 0.25rem
}.monogram-card__arrow {margin-top: 3px
}.monogram-card__arrow {display: inline-block
}.monogram-card__arrow {height: 1rem
}.monogram-card__arrow {width: 1rem
}@media (min-width: 1024px) {.monogram-card__arrow {margin-top: 0.25rem
  }
}
`;